import { useState } from "react";
import RichTextEditor from "./richtext/RichTextEditor";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function AddList() {
    const [name, setName] = useState("");
    const [items, setItems] = useState([]);

    const navigate = useNavigate();

    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {name: name, items: items};
        try {
            await axiosPrivate.post(
                "/lists",
                payload,
                {headers: {Authorization: "Bearer " + auth.accessToken}}
            );
            navigate("/lists");
        } catch(err) {
            console.log(err);
        }
    }

    const initialSlateValue = [{type: 'paragraph', children: [{text: ''}]}];

    return (
        <form onSubmit={handleSubmit}>
            <select 
                id="name"
                name="name"
                value={name}
                onChange={(evt) => setName(evt.target.value)}
                required
                className="w-auto px-4 py-2 mb-4 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
                <option value="">Choose Name</option>
                <option value="branches">Branches</option>
                <option value="faqs">FAQs</option>
            </select>
            <div className="pb-4">
                <RichTextEditor initialValue={initialSlateValue} setValue={setItems} />
            </div>
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    )
}

export default AddList;